import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Trash2, FileText } from 'lucide-react';
import { getSubjectName } from '../../../utils/quizUtils';

const ContentItem = memo(({ 
  content, 
  isTeacher, 
  onUnassign, 
  onViewResults, 
  onOpenContent 
}) => {
  const handleUnassignClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    onUnassign(content.id);
  }, [content.id, onUnassign]);

  const handleViewResultsClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    onViewResults(content.id, content.title);
  }, [content.id, content.title, onViewResults]);

  const handleContentClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    onOpenContent(content.id);
  }, [content.id, onOpenContent]);

  return (
    <div className="p-4 bg-pink-50 rounded shadow">
      <div className="flex justify-between items-start">
        {/* コンテンツ情報部分 */}
        <div className="flex-1">
          <div 
            className="cursor-pointer hover:text-purple-600"
            onClick={handleContentClick}
          >
            <h3 className="text-lg font-semibold text-purple-700">{content.title}</h3>
          </div>
          <div className="mt-2">
            <p className="text-sm text-gray-600">教科: {getSubjectName(content.subject)}</p>
            <p className="text-sm text-gray-600">出題順序: {content.randomizeQuizzes ? 'ランダム' : '固定'}</p>
            {content.timeLimitPerQuestion > 0 && !content.freeNavigation && (
              <p className="text-sm text-gray-600">1問あたりの制限時間: {content.timeLimitPerQuestion}秒</p>
            )}
            {content.freeNavigation && content.timeLimitPerContent > 0 && (
              <p className="text-sm text-gray-600">コンテンツ全体の制限時間: {content.timeLimitPerContent}秒</p>
            )}
            <p className="text-sm text-gray-600">問題移動: {content.freeNavigation ? '自由' : '一方向'}</p>
            <p className="text-sm text-gray-600">
              解答表示モード: {content.answerRevealMode === 'immediate' ? '即時表示' : '最後まとめ表示'}
            </p>
            <p className="text-sm text-gray-600">
              回答方式: {(content.quickAnswerMode || 'standard') === 'quick' ? 'クイック回答' : '標準回答'}
              {(content.quickAnswerMode || 'standard') === 'quick' && ' (四択・正誤問題)'}
            </p>
          </div>
        </div>

        {/* 操作ボタン部分 */}
        <div className="flex items-start gap-2 ml-4">
          <button
            onClick={handleViewResultsClick}
            className="p-2 text-purple-500 hover:text-purple-700 hover:bg-purple-100 rounded"
            aria-label="結果を確認"
          >
            <FileText size={20} />
          </button>
          {isTeacher && (
            <button
              onClick={handleUnassignClick}
              className="p-2 text-pink-500 hover:text-pink-700 hover:bg-pink-100 rounded"
              aria-label="割り当て解除"
            >
              <Trash2 size={20} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
});

ContentItem.displayName = 'ContentItem';

ContentItem.propTypes = {
  content: PropTypes.object.isRequired,
  isTeacher: PropTypes.bool.isRequired,
  onUnassign: PropTypes.func.isRequired,
  onViewResults: PropTypes.func.isRequired,
  onOpenContent: PropTypes.func.isRequired,
};

export default ContentItem; 